import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { LocalBusinessLd } from "@/lib/seo";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <LocalBusinessLd />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
